import { WidgetResult } from '../../../../core/hooks/useAnalytics';
import type Localiser from '../../../../core/modules/Localiser';
import type { Site } from '../../../../core/modules/sites/Site';
import type { WidgetProps } from '../../../../core/types/WidgetProps';
import { WidgetType } from '../../../../core/types/WidgetType';
import { renderWidget } from '../../renderWidget';

export type ProcessedWidget = {
  type: WidgetType;
  result: WidgetResult;
  props: WidgetProps;
};

type ProcessWidgetConfig = {
  articleId?: string;
  articleName: string;
  articleType?: string;
  articleUrl: string;
  editorialOnPage: boolean;
  element: HTMLElement;
  keywords?: string[];
  localiser: Localiser;
  site: Site;
  territory?: string;
  index: number;
};

export const processWidget = async (
  config: ProcessWidgetConfig,
): Promise<ProcessedWidget | null> => {
  const {
    articleId,
    articleName,
    articleType,
    articleUrl,
    editorialOnPage,
    element,
    keywords,
    localiser,
    site,
    territory,
    index,
  } = config;
  /* Ignore widgets without a widget type and set up a new index for each rendered widget
  This ensures we generate a different id if there are duplicate widgets on the page
  (e.g., 2 editorial widgets for the same model & widget type) */
  // TODO(Petr): Why do we even need widget ID?
  if (element.getAttribute('data-widget-type')) {
    return renderWidget({
      articleId,
      articleName,
      articleType,
      articleUrl,
      cacheBust: false,
      editorialOnPage,
      placeholder: element,
      index: index + 1,
      keywords,
      localiser,
      now: undefined,
      site,
      territory,
    });
  }

  return null;
};
